import {
    EMAILRULE_TICKET_GET_DATA,
    EMAIL_RULE_GET_DETAILS_DATA, 
    EMAILRULE_FORM_ADD_DATA,
    EMAILRULE_UPDATE_DATA,
    EMAILRULE_DELETE_DATA,
} from './Constants'

// get all emailrule listing
const loadEmailRuleTicketDataRequest = () => ({
  type: EMAILRULE_TICKET_GET_DATA.EMAILRULE_TICKET_GET_DATA_LOAD,
});
const setEmailRuleTicketDataSuccess = (emailrulelist) => ({
  type: EMAILRULE_TICKET_GET_DATA.EMAILRULE_TICKET_GET_DATA_SUCCESS,
  emailrulelist,
});
const setEmailRuleTicketDataFail = (error) => ({
  type: EMAILRULE_TICKET_GET_DATA.EMAILRULE_TICKET_GET_DATA_FAIL,
  error,
});

//Get by id
const loadEmailRuleGetDataRequest = (id) => ({
  type: EMAIL_RULE_GET_DETAILS_DATA.EMAIL_RULE_GET_DETAILS_DATA_LOAD,
  id,
});

const setEmailRuleGetDataSuccess = (emailrule) => ({
  type: EMAIL_RULE_GET_DETAILS_DATA.EMAIL_RULE_GET_DETAILS_DATA_SUCCESS,
  emailrule,
});

const setEmailRuleGetDataFail = (error) => ({
  type: EMAIL_RULE_GET_DETAILS_DATA.EMAIL_RULE_GET_DETAILS_DATA_FAIL,
  error,
});

//For add emailrule
const loadEmailRuleFormAddDataRequest = (request) => ({
  type: EMAILRULE_FORM_ADD_DATA.EMAILRULE_FORM_ADD_DATA_LOAD,
  request,
});
const setEmailRuleFormAddDataSuccess = (emailruleform) => ({
  type: EMAILRULE_FORM_ADD_DATA.EMAILRULE_FORM_ADD_DATA_SUCCESS,
  emailruleform,
});
const setEmailRuleFormAddDataFail = (error) => ({
  type: EMAILRULE_FORM_ADD_DATA.EMAILRULE_FORM_ADD_DATA_FAIL,
  error,
});
const ResetEmailRuleFormAddDataReset = () => ({
  type: EMAILRULE_FORM_ADD_DATA.EMAILRULE_FORM_ADD_DATA_RESET,
});


//For Edit emailrule
const loadEmailRuleUpdateDataRequest = (request) => ({
  type: EMAILRULE_UPDATE_DATA.EMAILRULE_UPDATE_DATA_LOAD,
  request
})

const setEmailRuleUpdateDataSuccess = (emailrule) => ({
  type: EMAILRULE_UPDATE_DATA.EMAILRULE_UPDATE_DATA_SUCCESS,
  emailrule,
})

const setEmailRuleUpdateDataFail = (error) => ({
  type: EMAILRULE_UPDATE_DATA.EMAILRULE_UPDATE_DATA_FAIL,
  error
})

const resetEmailRuleFormUpdateData = () => ({
  type: EMAILRULE_UPDATE_DATA.EMAILRULE_UPDATE_DATA_RESET,
});


// Delete emailrule
const loadEmailRuleDeleteDataRequest = (id) => ({
  type: EMAILRULE_DELETE_DATA.EMAILRULE_DELETE_LOAD,
  id,
});
const setEmailRuleDeleteDataSuccess = (emailrule) => ({
  type: EMAILRULE_DELETE_DATA.EMAILRULE_DELETE_SUCCESS,
  emailrule,
});

const setEmailRuleDeleteDataFail = (error) => ({
  type: EMAILRULE_DELETE_DATA.EMAILRULE_DELETE_FAIL,
  error,
});
const ResetEmailRuleDeleteDataReset = () => ({
  type: EMAILRULE_DELETE_DATA.EMAILRULE_DELETE_RESET,
});


export {
    loadEmailRuleTicketDataRequest, setEmailRuleTicketDataFail, setEmailRuleTicketDataSuccess,
    loadEmailRuleGetDataRequest, setEmailRuleGetDataFail, setEmailRuleGetDataSuccess,
    loadEmailRuleFormAddDataRequest, setEmailRuleFormAddDataFail, setEmailRuleFormAddDataSuccess,ResetEmailRuleFormAddDataReset,
    loadEmailRuleUpdateDataRequest, setEmailRuleUpdateDataFail, setEmailRuleUpdateDataSuccess,resetEmailRuleFormUpdateData,
    loadEmailRuleDeleteDataRequest, setEmailRuleDeleteDataFail, setEmailRuleDeleteDataSuccess, ResetEmailRuleDeleteDataReset,
    
}